export default __webpack_public_path__ + "static/media/FAVICON_43.eb025fff.png";